import { FC } from 'react';
import { cn } from '@/shared/lib';
import { useRTL } from '@/shared/hooks';
import { Switch } from '@/shared/shadcn';
import { useTranslation } from 'react-i18next';
import { selectIsMinimalistic, useAppSelector } from '@/app/store';
import { Typography } from '@/shared/components';
import { HandPlatter, ShoppingBagIcon } from 'lucide-react';

interface BasketOptionSwitcherProps {
  checked: boolean;
  isTakeout?: boolean;
  onCheckedChange: (val: boolean) => void;
}

export const BasketOptionSwitcher: FC<BasketOptionSwitcherProps> = ({
  checked,
  onCheckedChange,
  isTakeout = false,
}) => {
  const isRTL = useRTL();
  const { t } = useTranslation('basket');
  const isMinimalistic = useAppSelector(selectIsMinimalistic);

  return (
    <div
      className={cn(
        'flex flex-row gap-4 items-center rounded-md border border-solid p-4',
        isMinimalistic && 'rounded-none',
      )}
    >
      {isTakeout ? (
        <HandPlatter size={24} className='flex-shrink-0' />
      ) : (
        <ShoppingBagIcon size={24} className='flex-shrink-0' />
      )}

      <Typography variant='text3' className={cn('flex-1', isRTL && 'text-right')}>
        {t(isTakeout ? 'order.eatAtThePlace' : 'order.leaveAtTheDoor')}
      </Typography>

      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  );
};
